export const FeedExportFilterOptions = [
  {value: 'status', label: 'Status', type: 'status'},
  {value: 'format', label: 'Format', type: 'string'},
  {value: 'filename', label: 'File Name', type: 'string'},
]
